var EType;
(function (EType) {
    EType["INCOGNITO_MODE"] = "INCOGNITO_MODE";
    EType["CUSTOM_PERIOD"] = "CUSTOM_PERIOD";
    EType["MAX_CAPACITY"] = "MAX_CAPACITY";
})(EType || (EType = {}));
export { EType };
